<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <div class="col-12 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle d-block">Produtos</span>
        <h3 class="page-title d-inline">Tabela de Preços</h3>
        <d-button
          class="btn-primary float-right"
          @click.prevent="openBulkUpdateModal"
        >
          Atualizar preço em massa
        </d-button>
      </div>
    </d-row>

    <d-row>
      <d-col>
        <d-card class="card-small mb-4">
          <div class="card-header border-bottom d-flex flex-wrap justify-content-around">
            <div class="col-12 col-lg-4">
              <h6 class="m-0">Produtos</h6>
            </div>
            <div class="col-12 col-lg-2 mt-lg-0 mt-1">
              <d-select class="form-control ml-lg-3" size="sm" v-model="selectedPriceNames">
                <option value="ALL">Todas</option>
                <option v-for="type in priceTables" :key="type.id" :value="type.name">
                  {{ type.name }}
                </option>
              </d-select>
            </div>
            <div class="col-12 col-lg-2 mt-lg-0 mt-1">
              <d-select v-model="pagination.available" size="sm" class="form-control" @change="onAvailableChange">
                <option v-for="option in availableOptions" :key="option.value" :value="option.value">
                  {{ option.text }}
                </option>
              </d-select>
            </div>
            <div class="col-12 col-lg-4 mt-lg-0 mt-1">
              <form class="main-sidebar__search w-100 d-flex">
                <div class="input-group input-group-seamless ml-lg-3">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i class="fas fa-search"></i>
                    </div>
                  </div>
                  <input class="navbar-search form-control" type="text" placeholder="Procurar por algo..."
                    aria-label="Search" v-model="pagination.search">
                </div>
              </form>
            </div>
          </div>

          <div class="pb-3">
            <div class="table-overflow">
              <price-table-list-table :price-types.sync="priceTables" :products="products.list"
                :selected-price-names="selectedPriceNames" />
            </div>
            <pagination :total-items="products.total_items" :pagination.sync="pagination"></pagination>
          </div>
        </d-card>
      </d-col>
    </d-row>

    <bulk-price-update-modal
      :price-tables="priceTables"
      @updated="getList"
    />
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Pagination from '_shared/Pagination.vue';
import PriceTableListTable from '../components/PriceTableListTable.vue';
import BulkPriceUpdateModal from '../components/modal/BulkPriceUpdateModal.vue';
import { DEFAULT_PRICE_NAME, PRODUCT_AVAILABLE_OPTIONS, PRODUCT_AVAILABLE_TRUE } from '../components/ProductModel';

const BULK_PRICE_UPDATE_MODAL = 'bulk_price_update_modal';

export default {
  name: 'product-price-table',
  components: {
    PriceTableListTable,
    Pagination,
    BulkPriceUpdateModal,
  },
  data() {
    return {
      selectedPriceNames: 'ALL',
      pagination: {
        search: '',
        available: PRODUCT_AVAILABLE_TRUE,
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
      },
      availableOptions: PRODUCT_AVAILABLE_OPTIONS,
    };
  },
  computed: {
    products() {
      const { priceTableVariationsList } = this.$store.state.product;
      if (priceTableVariationsList && priceTableVariationsList.list.length) {
        return priceTableVariationsList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
    priceTables() {
      const { priceTableNames } = this.$store.state.product;
      const namedTables = priceTableNames && priceTableNames.list.length
        ? priceTableNames.list
        : [];

      return [{
        id: null,
        name: DEFAULT_PRICE_NAME,
      }, ...namedTables];
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getPriceTableVariationsList',
      'getPriceTableNames',
    ]),
    getListAll() {
      this.getPriceTableNames(this.pagination);
    },
    getList() {
      this.setToggle({ type: 'progress', bool: true });

      this.getPriceTableVariationsList(this.pagination)
        .finally(() => {
          this.setToggle({ type: 'progress', bool: false });
        });
    },
    onAvailableChange() {
      this.pagination.page = 1;
      this.pagination.skip = 0;
    },
    openBulkUpdateModal() {
      this.setToggle({ type: BULK_PRICE_UPDATE_MODAL, bool: true });
    },
  },
  mounted() {
    Events.$emit('sidebarVisible', false);
    Events.$on('update:pagination', pagination => {
      this.$router.push({ params: { page: pagination.page } });
      this.getList();
    });
    this.getList();
    this.getListAll();
  },
};
</script>

<style scoped lang="scss">
@import '~_scss/overrides';
</style>
